import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/shared/API-Service/services/setting.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-DonationWayFile',
  templateUrl: './DonationWayFile.component.html',
  styleUrls: ['./DonationWayFile.component.css']
})
export class DonationWayFileComponent implements OnInit {
  PdfFile: File;
  Pdf: string;
  PdfFileForm : FormGroup;
  PdfFileFormData : FormData
  button: boolean;
  update: boolean;
  PdfFileData: any;
  id: any;
  readonly allowedFileTypes = ['application/pdf'];

 constructor(private _Router:Router,private _FormBuilder:FormBuilder,private SettingService:SettingService) { 
    this.initiate();
  }

  ngOnInit(): void {
    this.GetFile();
}
GetFile(){
  this.SettingService.GetFile().subscribe(async (res:any)=>{
    console.log(res.data);
  this.PdfFileData=  await res.data;
  this.id =this.PdfFileData.id;

  this.Pdf=environment.ServerImages_URL+'/'+this.PdfFileData.pdfpath
  this.initiate(this.PdfFileData);
    
  })
}
OpenPdf(imagesView){
  window.open(imagesView, "_blank");
}
  getFileUrl(event: any) {
    
    
    if (event.target.files[0].type==='application/pdf') {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.PdfFile = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.Pdf = reader.result as string;
        // this.logoForm?.append("image", this.Image);
      };

    }
    }    
  }
  updateappenddata(){
    this.PdfFileFormData = new FormData();
    console.log(this.PdfFile)
    if (this.PdfFile) this.PdfFileFormData.set("FilePath", this.PdfFile);
    // this.PdfFileFormData.append("Id", this.id);
  }
  

   initiate(PdfFile?:any){
  console.log(PdfFile)
  this.PdfFileForm = this._FormBuilder.group({});

    }
    onSubmit(){
      this.button = true;
      if(this.PdfFileForm.status == "VALID"){
       this.updateappenddata();
      this.SettingService.UploadFile(this.PdfFileFormData).subscribe((res) => {
        Swal.fire({
          icon: "success",
          title: "تم التعديل بنجاح",
          showConfirmButton: false,
          timer: 1500,
        });
        this.PdfFileForm.reset();
        

        this.GetFile()
      },(err) => {
        Swal.fire({
          icon: 'error',
          title: 'خطأ',
          text:err.message    
        }) 
      }, () => {
        console.log('completed ');
      })
     }
     else {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:"بالرجاء التأكد من ملئ جميع الحقول"   
      })
      this.PdfFileForm.markAllAsTouched();
      this.button = false;
     }
    }
}
